import React, { useEffect, useState } from "react";
import { Card, Typography, Descriptions, Spin, Row, Col, Avatar } from "antd";
import { useParams } from "react-router-dom";
import axios from "axios";

const { Title, Paragraph } = Typography;

const TeamDetail = () => {
  const { id } = useParams();
  const [teamMember, setTeamMember] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTeamMember();
  }, [id]);

  const fetchTeamMember = async () => {
    try {
      const response = await axios.get(`http://93.127.203.113:5005/team/${id}`);
      setTeamMember(response.data);
    } catch (error) {
      console.error("Error fetching team member:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: "40px", display: "flex", justifyContent: "center" }}>
      {loading ? (
        <Spin size="large" />
      ) : (
        <Card
          style={{
            width: "80%",
            maxWidth: "900px",
            padding: "20px",
            borderRadius: "10px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Row gutter={[24, 24]} align="middle">
            {/* Left Column - Image */}
            <Col xs={24} md={8} style={{ textAlign: "center" }}>
              {teamMember?.image ? (
                <img
                  src={`http://93.127.203.113:5005${teamMember.image}`}
                  alt="Profile"
                  style={{
                    width: "100%",
                    maxWidth: "180px",
                    borderRadius: "10px",
                    border: "3px solid #0c8c49",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                  }}
                />
              ) : (
                <Avatar
                  size={180}
                  style={{
                    backgroundColor: "#0c8c49",
                    fontSize: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {teamMember?.name?.charAt(0) || "?"}
                </Avatar>
              )}
            </Col>

            {/* Right Column - Details */}
            <Col xs={24} md={16}>
              <Title level={3} style={{ color: "#0c8c49", marginBottom: "10px" }}>
                {teamMember?.name}
              </Title>
              <Paragraph type="secondary" style={{ fontSize: "16px", marginBottom: "15px" }}>
                <strong>Job Position:</strong> {teamMember?.job || "N/A"}
              </Paragraph>
              <Card
                style={{
                  backgroundColor: "#f9f9f9",
                  padding: "15px",
                  borderRadius: "8px",
                  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.08)",
                }}
              >
                <Descriptions column={1} bordered>
                  <Descriptions.Item label="Full Name">{teamMember?.name || "N/A"}</Descriptions.Item>
                  <Descriptions.Item label="Position">{teamMember?.job || "N/A"}</Descriptions.Item>
                </Descriptions>
              </Card>
            </Col>
          </Row>
        </Card>
      )}
    </div>
  );
};

export default TeamDetail;
